import { render } from "./PlaceholderPage.vue?vue&type=template&id=28263223"
import script from "./PlaceholderPage.vue?vue&type=script&lang=js"
export * from "./PlaceholderPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__